import { ICommandBarItemProps, MessageBar, MessageBarType, Toggle } from '@fluentui/react';
import { RouterParams } from 'App';
import { RootState } from 'app/store';
import { fadeIn } from 'global/Application';
import { addUpdateORE } from 'global/Reducer/dataSlice';
import { IAccountExtended, Ibcbs_groupconfigurationsnapshot_extended } from 'model/CRM.type';
import {
    $cat_$capital_prime_id,
    $cat_$florida_prime_id
} from 'model/ConfigCategoryConstants';
import { IPharmacyORE } from 'model/FlexibleAttributeModel';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import GroupConfigurationSnapshotContext from 'views/BlueRelationship/GroupConfigurationSnapshotContext';
import { IPharmacyPrimeViewModel } from '../Models/IViewModel';
import PharmacyPlan from './PharmacyPlan';

export interface IPharmacyPlanContextProps {
    isFloridaPrime?: boolean;
    isCapitalPrime?: boolean;
}

const PharmacyPlanContext: React.FC<IPharmacyPlanContextProps> = (props) => {

    const state = useSelector((state: RootState) => state);
    const dispatch = useDispatch();

    const { pharmacyId } = useParams<RouterParams>();

    const viewModel = useMemo(() => {

        const floridaPrimeCategory = state.data.config?.cache?.map_bcbs_config_category[$cat_$florida_prime_id];

        const capitalPrimeCategory = state.data.config?.cache?.map_bcbs_config_category[$cat_$capital_prime_id];

        const json = state.data.json;

        if (!json)
            return null;

        const pre = json.pharmacyORE?.find(p => p.id === pharmacyId);

        const plan = json.plans.find(p => p.id === pre?.id) ?? null;

        const benefits = plan?.benefitRefs.map(ref => json.benefits.find(b => b.id === ref.id)!);

        const medicalCategory = state.data.config.cache?.map_bcbs_config_category_named.Medical;

        const floridaPrimeBenefit = benefits?.find(b => b.bcbs_config_categoryid == floridaPrimeCategory?.bcbs_config_categoryid) ?? null;
        const capitalPrimeBenefit = benefits?.find(b => b.bcbs_config_categoryid == capitalPrimeCategory?.bcbs_config_categoryid) ?? null;

        const primeBenefit = floridaPrimeBenefit ? floridaPrimeBenefit : capitalPrimeBenefit;

        const medicalBenefit = benefits?.find(b => b.bcbs_config_categoryid == medicalCategory.bcbs_config_categoryid) ?? null;

        if (!pre || !plan || !benefits || !primeBenefit)
            return null;

        const viewModel: IPharmacyPrimeViewModel = {
            pharmacyExtract: pre,
            plan,
            benefits: benefits,
            primeCategory: floridaPrimeBenefit ? floridaPrimeCategory : capitalPrimeCategory,
            primeBenefit: primeBenefit,
            medicalCategory: medicalCategory!,
            medicalBenefit: medicalBenefit!,
            snapshot: state.data.snapshot as Ibcbs_groupconfigurationsnapshot_extended,
            json: json,
            account: state.data?.account as IAccountExtended,
        };

        return viewModel;
    }, [state, pharmacyId]);


    const contextMenu = useMemo(() => {

        const contextMenu = {
            items: [] as ICommandBarItemProps[],
            key: 'menu.pharmacy'
        };

        const contextMenuItems = contextMenu.items;

        if (!viewModel)
            return contextMenu;

        contextMenuItems.push(
            {
                key: 'updateClientNumber',
                name: 'Update Client Number',
                iconProps: { iconName: 'Edit' },
                onClick: (event, item) => {
                    if (event?.stopPropagation)
                        event.stopPropagation();

                    const newClientNumber = prompt("Enter client number", viewModel.pharmacyExtract?.newClientNumber ?? "")

                    if (!newClientNumber)
                        return;

                    const pre: IPharmacyORE = {
                        ...viewModel.pharmacyExtract,
                        newClientNumber: newClientNumber ?? ""
                    };

                    dispatch(addUpdateORE([pre]));
                },
            });

        contextMenuItems.push(
            {
                key: 'updatePlanDesign',
                name: 'Update Plan Design',
                iconProps: { iconName: 'Edit' },
                onClick: (event, item) => {
                    if (event?.stopPropagation)
                        event.stopPropagation();

                    const newPharmacyPlanDesign = prompt("Enter new Plan Design", viewModel.pharmacyExtract?.newPharmacyPlanDesign ?? "")

                    if (!newPharmacyPlanDesign)
                        return;

                    const pre: IPharmacyORE = {
                        ...viewModel.pharmacyExtract,
                        newPharmacyPlanDesign: newPharmacyPlanDesign,
                    };

                    dispatch(addUpdateORE([pre]));
                },
            });

        contextMenuItems.push(
            {
                key: 'readyForRelease',
                name: 'Ready for Release',
                onRender: (item, dismissMenu) => {
                    return <Toggle
                        inlineLabel
                        label="Release"
                        styles={{ root: { padding: '5px', marginBottom: '0' } }}
                        onClick={e => e.stopPropagation()}
                        onKeyDown={e => e.stopPropagation()}
                        checked={viewModel.pharmacyExtract.releaseStatus === "Ready for Release"}
                        onChange={(event, checked) => {
                            if (event?.stopPropagation)
                                event.stopPropagation();

                            const pre: IPharmacyORE = {
                                ...viewModel.pharmacyExtract,
                                releaseStatus: checked ? "Ready for Release" : "In Progress",
                            };

                            dispatch(addUpdateORE([pre]));
                        }}
                    />
                },
            });

        return contextMenu;

    }, [viewModel]);

    return (
        <GroupConfigurationSnapshotContext
            contextMenu={contextMenu}
            unStickyNavbar={true}
        >
            {!viewModel &&
                <MessageBar className={fadeIn} messageBarType={MessageBarType.warning} styles={{ root: { marginTop: '10px' } }}>
                    No Prime pharmacy found.
                </MessageBar>
            }
            {viewModel &&
                <PharmacyPlan
                    viewModel={viewModel}
                    context={props}
                />
            }
        </GroupConfigurationSnapshotContext>
    );
};

export default PharmacyPlanContext;